import { render, staticRenderFns } from "./PremiumAmount.vue?vue&type=template&id=4475ad48"
import script from "./PremiumAmount.vue?vue&type=script&lang=js"
export * from "./PremiumAmount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports